// Domain
import { AuthScenariosEnumeration } from 'providers/auth-watcher/enumerations/auth-scenarios.enumeration';

const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.authWatcherProvider.';

const AUTH_WATCHER_TITLE = `${DOMAIN}title`,
  AUTH_WATCHER_DESCRIPTIONS = {
    [AuthScenariosEnumeration.ABOUT_EXPIRING]: `${DOMAIN}aboutExpiringDescription`,
    [AuthScenariosEnumeration.ACCESS]: `${DOMAIN}accessDescription`,
    [AuthScenariosEnumeration.REFRESH]: `${DOMAIN}refreshDescription`,
    [AuthScenariosEnumeration.REDIRECTING]: `${DOMAIN}redirectingDescription`,
  };

export { AUTH_WATCHER_TITLE, AUTH_WATCHER_DESCRIPTIONS };
